import React from "react";
import styled from "styled-components";

const Theme = {
    spacing: "0 auto 80px",
    max: "100%",
    mobileSpacing: "0 auto 30px"
};

export { Theme };